// API Configuration
// This file contains the base URL for all API requests

// Development environment
// const API_BASE_URL = 'http://localhost:8000/'; // http://192.168.1.3:8000

// Production environment (uncomment when deploying)
const API_BASE_URL = 'https://api.haseela.online';

export const apiBaseUrl = API_BASE_URL;

export const API_TIMEOUT = 30000;

export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};

const config = {
    apiBaseUrl,
    API_TIMEOUT,
    DEFAULT_HEADERS,
};

export default config;
